import React, {h, Component} from 'preact';
import {createHashHistory, Action} from 'history';
import URLSearchParams from 'core-js/web/url-search-params';
import ExitIntentModal from './ExitIntentModal/ExitIntentModal';
import ProgressBar from './ProgressBar';
import SellOrBuyStep from './SellOrBuyStep';
import Spinner from './Spinner';

import SellHomeTypeStep from './SellHomeTypeStep';
import SellPriceRangeStep from './SellPriceRangeStep';
import SellAgentPreferenceStep from './SellAgentPreferenceStep';
import SellExpectedListDateStep from './SellExpectedListDateStep';
import SellContactFormStep from './SellContactFormStep';
import SellContactFormStep1 from './SellContactFormStep1';
import SellContactFormStep2 from './SellContactFormStep2';
import LoginLinkStep from './LoginLinkStep';

import BuyPriceRangeStep from './BuyPriceRangeStep';
import BuyHomeTypeStep from './BuyHomeTypeStep';
import BuyProcessStep from './BuyProcessStep';
import BuyCreditScoreStep from './BuyCreditScoreStep';
import BuyFinancingStep from './BuyFinancingStep';
import BuyContactFormStep from './BuyContactFormStep';
import SellAndBuyAddressStep from './SellAndBuyAddressStep';
import SellAndBuyContactStep from './SellAndBuyContactStep';

//
// Different steps must render as different components, otherwise React will just update them instead of re-mounting,
// and as a result will not call componentDidMount(), as expected by some components.
//
class SellAndBuySellAddressStep extends SellAndBuyAddressStep {}
class SellAndBuyBuyLocationStep extends SellAndBuyAddressStep {}

export default class ReactBuySellFlow extends Component {
    constructor(props) {
        super(props);

        let currentStep;
        if (props.realtorId) {
            currentStep = props.isBuyer ? 'BUY_CONTACT_FORM' : 'SELL_CONTACT_FORM';
        } else if (props.address && props.tabbedFlow != '1') {
            currentStep = 'SELL_CONTACT_FORM';
        } else {
            currentStep = 'SELL_OR_BUY';
        }

        if (props.address) {
            $.post('api/validateDirectSubmit-json', {
                'prop.address': props.address,
                city: props.city,
                state: props.state,
            }).then(data => {
                if (data.redirectUrl) {
                    window.location = data.redirectUrl;
                    return;
                }
                const addressDetails = this.addressDetails || {};
                if (data.skipAddressNormalization) {
                    addressDetails.streetAddress = data.prop.address;
                    addressDetails.city = data.prop.city;
                    addressDetails.addressComponents = data.prop.addressComponents;
                    addressDetails.state = data.prop.state;
                    addressDetails.zip = data.prop.zip;
                    addressDetails.country = data.prop.country;
                    addressDetails.mapLongitude = data.prop.mapLongitude;
                    addressDetails.mapLatitude = data.prop.mapLatitude;
                    addressDetails.MSA = data.prop ? data.prop.MSA : null;
                    addressDetails.county = data.prop ? data.prop.county : null;
                    this.addressDetails = addressDetails;
                }
                if (data.skipFetchingEstimate) {
                    addressDetails.estimate = (data.req || {}).zestimate;
                    addressDetails.prop = data.prop;
                    addressDetails.baths = data.prop ? data.prop.baths : null;
                    addressDetails.beds = data.prop ? data.prop.beds : null;
                    addressDetails.finishedSqFt = data.prop ? data.prop.finishedSqFt : null;
                    addressDetails.homeType = data.prop ? data.prop.homeType : null;
                    this.addressDetails = addressDetails;
                }

            });
        }

        this.state = {
            currentStep: currentStep,
            requestId: ''
        };

        const geocoder = new google.maps.Geocoder();
        this.locationBiasPromise = $.Deferred();
        geocoder.geocode({address: this.props.city + ', ' + this.props.state}, (results, status) => {
            let result = status === google.maps.GeocoderStatus.OK ? results[0].geometry.bounds : null;
            this.locationBiasPromise.resolve(result);
        });

        this.history = createHashHistory();
    }

    componentDidMount() {
        this.removeHistoryListener = this.history.listen(({location, action}) => {
            if (this.exited) {
                return;
            }
            if (action == Action.Pop) {
                const step = new URLSearchParams(location.search).get('step');
                this.isPopInProgress = true;
                if (step && step != 'undefined') {
                    this.setState({currentStep: step});
                } else {
                    this.history.back(); // Back to previous page
                }
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.currentStep !== prevState.currentStep) {
            if (this.exited) {
                return;
            }
            const step = this.state.currentStep;
            if (step != 'LOADING') {
                if (this.isPopInProgress) {
                    this.isPopInProgress = false;
                } else {
                    this.history.push('?step=' + encodeURIComponent(step));
                }
            }
        }
    }

    componentWillUnmount() {
        if (this.removeHistoryListener) {
            this.removeHistoryListener();
        }
    }

    exitFlow(isBuyer) {
        this.exited = true;

        // Give the pixels' network requests some time to finish before redirecting.
        setTimeout(() => {
            if (isBuyer) {
                window.location.replace('buyer-invite-progress?requestId=' + this.state.requestId);
            } else {
                window.location.replace('seller-invite-progress?requestId=' + this.state.requestId + "&flow=" + this.props.flow);
            }
        }, 1000);
    }

    renderStep() {
        switch (this.state.currentStep) {
            case 'SELL_OR_BUY':
                return <SellOrBuyStep {...this.props} parent={this}/>;
            case 'SELL_HOME_TYPE':
                return <SellHomeTypeStep {...this.props} parent={this}/>;
            case 'SELL_PRICE_RANGE':
                return <SellPriceRangeStep {...this.props} parent={this}/>;
            case 'SELL_AGENT_PREF':
                return <SellAgentPreferenceStep {...this.props} parent={this}/>;
            case 'SELL_EXPECTED_LIST_DATE':
                return <SellExpectedListDateStep {...this.props} parent={this}/>;
            case 'SELL_CONTACT_FORM1':
                return <SellContactFormStep1 {...this.props} parent={this}/>;
            case 'SELL_CONTACT_FORM2':
                return <SellContactFormStep2 {...this.props} parent={this}/>;
            case 'SELL_CONTACT_FORM':
                return <SellContactFormStep {...this.props} parent={this}/>;
            case 'SELL_CHAT':
                this.exitFlow(false);
                return <Spinner/>;
            case 'BUY_PRICE_RANGE':
                return <BuyPriceRangeStep {...this.props} parent={this}/>;
            case 'BUY_HOME_TYPE':
                return <BuyHomeTypeStep {...this.props} parent={this}/>;
            case 'BUY_PROCESS':
                return <BuyProcessStep {...this.props} parent={this}/>;
            case 'BUY_CREDIT_SCORE':
                return <BuyCreditScoreStep {...this.props} parent={this}/>;
            case 'BUY_FINANCING':
                return <BuyFinancingStep {...this.props} parent={this}/>;
            case 'BUY_CONTACT_FORM':
                return <BuyContactFormStep {...this.props} parent={this}/>;
            case 'BUY_CHAT':
                // Give the pixels' network requests some time to finish before redirecting.
                trackEvent('Flow', 'BuyRequest', 'buyerLoadedStep7').withGA().withOptimizely();
                this.exitFlow(true);
                return <Spinner/>;
            case 'SELL_AND_BUY_ADDRESS_STEP':
                return <SellAndBuySellAddressStep {...this.props} parent={this} buyLocationForm={false}/>;
            case 'SELL_AND_BUY_BUY_LOCATION_STEP':
                return <SellAndBuyBuyLocationStep {...this.props} parent={this} buyLocationForm={true}/>;
            case 'SELL_AND_BUY_CONTACT_STEP':
                return <SellAndBuyContactStep {...this.props} parent={this}/>;
            case 'LOGIN_LINK':
                return <LoginLinkStep {...this.props} {...this.state.loginLinkProps} parent={this}/>;
            case 'LOADING':
                return <Spinner/>;
        }
    }

    render() {
        return (
            <div>
                <ProgressBar
                    isBuyer={this.state.isBuyer}
                    alsoBuying={this.state.alsoBuying}
                    currentStep={this.state.currentStep}
                    sellBuyLocationForm={this.state.sellBuyLocationForm}
                />
                {this.renderStep()}
                {!['SELL_OR_BUY', 'SELL_CHAT', 'BUY_CHAT'].includes(this.state.currentStep) && (
                    <ExitIntentModal
                        stateFullName={this.props.stateFullName}
                        savings={this.props.savings}
                        isBuyer={this.state.isBuyer}
                        currentStep={this.state.currentStep}
                    />
                )}
            </div>
        );
    }
}
